export default __webpack_public_path__ + "static/media/escalator.inline.09d2fe71.svg";